const KB = 1024;
const MB = KB * 1024;

/**
 * Largest unit that fits, to two decimals. Bytes stay whole because a fraction
 * of a byte is not a thing.
 */
const formatFileSize = (bytes: number): string => {
  if (bytes >= MB) return `${(bytes / MB).toFixed(2)} MB`;
  if (bytes >= KB) return `${(bytes / KB).toFixed(2)} KB`;
  return `${bytes} B`;
};

export default formatFileSize;
